var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-platform-setup.d1afadd9.png","uri@2x": __webpack_public_path__ + "icon-platform-setup.7e7f2b6e.png","uri@3x": __webpack_public_path__ + "icon-platform-setup.2bf9e15e.png",
    width: 32,
    height: 32
});